import React, { useState } from 'react';
import { safeParseLocalStorage } from '../utils/safeParseLocalStorage';

export const SeisoenContext = React.createContext({
    seisoene: {},
    setSeisoene: () => { },
    seisoen: {},
    setSeisoen: () => { },
    disabled: false,
    setDisabled: () => { },
    reload: false,
    setReload: () => { },
    refreshpage: false,
    setRefreshpage: () => { }
});

const SeisoenContextProvider = props => {
    const [seisoene, setSeisoene] = useState(safeParseLocalStorage("seisoene", []));
    const [disabled, setDisabled] = useState(false);
    const [seisoen, setSeisoen] = useState(safeParseLocalStorage("seisoen", {}));
    const [reload, setReload] = useState(0);
    const [refreshpage, setRefreshpage] = useState(false);

    const seisoeneHandler = seisoene => {
        setSeisoene(seisoene);
        localStorage.setItem("seisoene", JSON.stringify(seisoene));
    }

    const seisoenHandler = seisoen => {
        setSeisoen(seisoen);
        localStorage.setItem("seisoen", JSON.stringify(seisoen));
        setRefreshpage(true);
    }

    const disabledHandler = disabled => {
        setDisabled(disabled);
        localStorage.setItem("disabled", disabled);
    }

    return (
        <SeisoenContext.Provider
            value={{ stelseisoene: seisoeneHandler, seisoene: seisoene, stelseisoen: seisoenHandler, seisoen: seisoen, steldisabled: disabledHandler, disabled: disabled, reload: reload, stelreload: setReload, refreshpage: refreshpage, stelrefresh: setRefreshpage }}
        >
            {props.children}
        </SeisoenContext.Provider>
    )
}

export default SeisoenContextProvider;